export const subtitles = {
    "1": {
        "startTime": 2.19,
        "endTime": 6.0,
        "transcript": "...green-aaruaqameng nauqerraarqameng nutaan.",
        "translation": "...when they're green, freshly grown."
    },
    "2": {
        "startTime": 6.0,
        "endTime": 13.83,
        "transcript": "Tua-i qantamun kanevqaarluki, tua-i-llu uqumek kuvluki, luqruuyagnek kinertarnek avuluki nerluki.",
        "translation": "After putting them into a bowl, pour seal oil onto them, add in dried pike, then eat them."
    },
    "3": {
        "startTime": 13.87,
        "endTime": 16.34,
        "transcript": "Tua-i assiqapiarluteng.",
        "translation": "They are very good."
    },
    "4": {
        "startTime": 18.36,
        "endTime": 27.25,
        "transcript": "She said that she used to use those things to eat [?], and they mix them with seal oil.",
        "translation": "She said that she used to use those things to eat [?], and they mixed them with seal oil."
    },
    "5": {
        "startTime": 28.562,
        "endTime": 31.429,
        "transcript": "And then they also...",
        "translation": "And then they also..."
    },
    "6": {
        "startTime": 33.027,
        "endTime": 34.716,
        "transcript": "Yungcaristeńgullruut.",
        "translation": "They were healers."
    },
    "7": {
        "startTime": 35.702,
        "endTime": 39.946,
        "transcript": "Angalkunun wiinga piksaitellruama angalkut nalluanka.",
        "translation": "Because I've never gone to shamans, I don't know about them."
    },
    "8": {
        "startTime": 40.0,
        "endTime": 46.8,
        "transcript": "Angalkut-gguq... tamakut nallullruanka wiinga angalkumek tangaallrunrilama.",
        "translation": "They said that shamans... I don't know them because I didn't see shamans around."
    },
    "9": {
        "startTime": 47.274,
        "endTime": 52.13,
        "transcript": "Tua-i-w' nallukemnek pinritanka ukut tau͡gaam nallunriterrlainaqemnek.",
        "translation": "I'm not telling them about what I don't know, but only what I do know."
    },
    "10": {
        "startTime": 52.355,
        "endTime": 58.011,
        "transcript": "Nallunilaranka tua-i nallukenka. Nalluaqa tauna angalkum caliara.",
        "translation": "I say I don't know what I don't know. I don't know how shamans work."
    },
    "11": {
        "startTime": 60.121,
        "endTime": 68.543,
        "transcript": "She said she didn't go to any shamans, so therefore she can't tell you.",
        "translation": "She said she didn't go to any shamans, so therefore she can't tell you."
    },
    "12": {
        "startTime": 68.804,
        "endTime": 73.271,
        "transcript": "And she can't really talk about something she doesn't know.",
        "translation": "And she can't really talk about something she doesn't know."
    },
    "13": {
        "startTime": 73.357,
        "endTime": 76.791,
        "transcript": "Teq'uq-wa man'a niitetullrukeka.",
        "translation": "I used to hear about urine."
    },
    "14": {
        "startTime": 81.222,
        "endTime": 92.911,
        "transcript": "Qerruyarpialriamun, qerrutellriamun cakneq yuilqumi, qerruqatalriamun, qerruyarpialriamun kumlangluni qainga tamarmi",
        "translation": "To someone on the verge of freezing, someone who is very cold in the wilderness on the verge of freezing, on the verge of freezing with his whole body cold"
    },
    "15": {
        "startTime": 93.059,
        "endTime": 101.692,
        "transcript": "Teq'uq niitetuaqa nataqestiinun yuk tauna teq'urranek egmianun mercetetullruniluku.",
        "translation": "I heard that the person who found him would immediately have him drink his urine."
    },
    "16": {
        "startTime": 104.213,
        "endTime": 105.668,
        "transcript": "Elliin teq'urranek?",
        "translation": "His urine?"
    },
    "17": {
        "startTime": 105.885,
        "endTime": 113.007,
        "transcript": "Eliin taum yuum tekitellriim teq'uminek mertetetullruniluku qerruyarpialria.",
        "translation": "The person that came would give his urine for the one on the verge of freezing to drink."
    },
    "18": {
        "startTime": 118.938,
        "endTime": 126.216,
        "transcript": "She said that the one example that she knows is when urine was used",
        "translation": "She said that the one example that she knows is when urine was used"
    },
    "19": {
        "startTime": 126.25,
        "endTime": 135.605,
        "transcript": "Was when a person almost freezes or goes through hypothermia, when the body is already cool",
        "translation": "Was when a person almost freezes or goes through hypothermia, when the body is already cool"
    },
    "20": {
        "startTime": 136.846,
        "endTime": 147.279,
        "transcript": "She said the person who rescues that person or comes up to them would pee and let that person drink that urine.",
        "translation": "She said the person who rescues that person or comes up to them would pee and let that person drink that urine."
    },
    "21": {
        "startTime": 150.376,
        "endTime": 154.276,
        "transcript": "Nass', I heard that for the...",
        "translation": "Nass', I heard that for the..."
    },
    "22": {
        "startTime": 154.934,
        "endTime": 165.267,
        "transcript": "Niitellruunga wiinga au͡g'umek puqliinek cikirluku tauna, elliin taum yuum canrilnguum puqlaminek cikirluku ikayurluku.",
        "translation": "I heard that he gives him his warmth, that person who is well would help him by giving him his warmth."
    },
    "23": {
        "startTime": 166.603,
        "endTime": 170.948,
        "transcript": "She said that it was usually the one who...",
        "translation": "She said that it was usually the one who..."
    },
    "24": {
        "startTime": 171.063,
        "endTime": 174.908,
        "transcript": "...through that urine, the warmth, let it go through their body.",
        "translation": "...through that urine, the warmth, let it go through their body."
    },
    "25": {
        "startTime": 176.527,
        "endTime": 180.805,
        "transcript": "Teq'uq-wa tamaani ak'a iinruullrulria-llu.",
        "translation": "Back then, urine was also used medicinally."
    },
    "26": {
        "startTime": 190.998,
        "endTime": 195.998,
        "transcript": "Urine in those days was also treated as medicine.",
        "translation": "Urine in those days was also treated as medicine."
    },
    "27": {
        "startTime": 196.826,
        "endTime": 198.937,
        "transcript": "Qaillun-mi aturaqluku?",
        "translation": "How would they use it?"
    },
    "28": {
        "startTime": 200.077,
        "endTime": 206.066,
        "transcript": "Maa-i tanglartuci maa-i mat'um nalliini tuaten pirugalriartairucaaquq.",
        "translation": "Now, you see these days that there are not a lot who do that."
    },
    "29": {
        "startTime": 206.282,
        "endTime": 216.377,
        "transcript": "Tau͡gaam yuut-wa iqairucameng canek-llu naugiyuirutut naurrlugnek imkunek pupignek pitullritnek.",
        "translation": "But since people are cleaner, they have stopped breaking out with sores that they would call impetigo."
    },
    "30": {
        "startTime": 216.38,
        "endTime": 219.136,
        "transcript": "Yuut iqairutut mat'um nalliini.",
        "translation": "People are cleaner these days."
    },
    "31": {
        "startTime": 219.167,
        "endTime": 228.622,
        "transcript": "Tamatum-llu nausciigaliluki cam iqam ciissiin tamakut ukitesciigaliluku man'a temiit erurturangameng.",
        "translation": "The germs from dirt can no longer penetrate the body and cause it to break out because they consistently wash."
    },
    "32": {
        "startTime": 229.187,
        "endTime": 234.343,
        "transcript": "Tamaani ak'a erurturayuitellratni teq'uq iinruullruuq.",
        "translation": "Back when they didn't consistently wash, urine was used medicinally."
    },
    "33": {
        "startTime": 235.238,
        "endTime": 243.327,
        "transcript": "Mikelnguut ilait, taqnerunge'rmeng-llu ilait qamiqurrit callartetullruut pupigluki.",
        "translation": "Some children's, and even some adults' heads would break out with impetigo."
    },
    "34": {
        "startTime": 243.343,
        "endTime": 249.588,
        "transcript": "Tua-i ilaita-llu qamiqurrit tegg'iluteng pupigluki tua-i tamakunek.",
        "translation": "And some of their scalps would get hardened crusts from those stores."
    },
    "35": {
        "startTime": 249.871,
        "endTime": 253.96,
        "transcript": "Tau͡gaam tua-i teq'um assiritullrui.",
        "translation": "But urine would make them better."
    },
    "36": {
        "startTime": 254.944,
        "endTime": 264.899,
        "transcript": "Tamakut tua-i uqumek keniqaarluki, iciw' naulriit cat tegg'iyulalria man'a maqellra qamaken",
        "translation": "After soaking them in seal oil to soften them, you know how the discharge from inside those sores would harden"
    },
    "37": {
        "startTime": 265.27,
        "endTime": 270.67,
        "transcript": "Tamana tua-i uqumek keniarqaarluku, tua-i-ll' ken'iqercan",
        "translation": "After soaking that in seal oil to soften it, then when it softened"
    },
    "38": {
        "startTime": 270.755,
        "endTime": 285.632,
        "transcript": "Nutaan teq'umek uitallermek nutaraunrilngurmek tuknirilriamek qulilluki qamiqurrit erurluki.",
        "translation": "Finally, they would use aged urine, not fresh, that has become potent to wash their heads."
    },
    "39": {
        "startTime": 286.816,
        "endTime": 299.516,
        "transcript": "Erurraarluki-llu nutaan tamatum tukniallranek cali teq'umek puqlaksuarluku cali erunqiggluku qamiqurra qeltait au͡g'arluki.",
        "translation": "And after washing them, they would warm up less potent urine and was their heads again, taking off the scabs."
    },
    "40": {
        "startTime": 300.091,
        "endTime": 307.835,
        "transcript": "Nutaan-llu tuaten au͡g'arraarluki kingunrat cali uqurrluarmek mingugluku kineryailkucirluku.",
        "translation": "And then after removing them, they would apply a little seal oil to keep them from drying out."
    },
    "41": {
        "startTime": 308.335,
        "endTime": 314.401,
        "transcript": "Ak'anun naumayuitetunillruit tamaani ak'a teq'umek eruumalriit.",
        "translation": "They said that those washed with urine would not break out again for a long time."
    },
    "42": {
        "startTime": 315.097,
        "endTime": 322.364,
        "transcript": "Kitak' amci mumigtegu. Ayuquciiruciiqertek.",
        "translation": "Go ahead and translate it now. You'll forget what it's about."
    },
    "43": {
        "startTime": 322.637,
        "endTime": 327.326,
        "transcript": "[?] au͡gna nallunrilkemnek qanqacuayqaqerlii.",
        "translation": "[?] Let me mention something about what I know."
    },
    "44": {
        "startTime": 327.348,
        "endTime": 328.614,
        "transcript": "Una mumigtelaaggaarluku.",
        "translation": "Affter translating this."
    },
    "45": {
        "startTime": 328.654,
        "endTime": 330.654,
        "transcript": "Mumigtelakarraarluku atam.",
        "translation": "After translating it."
    },
    "46": {
        "startTime": 331.873,
        "endTime": 340.817,
        "transcript": "She says the other use for urine was, she said you see nowadays that nobody uses urine...",
        "translation": "She says the other use for urine was, she said you see nowadays that nobody uses urine..."
    },
    "47": {
        "startTime": 341.728,
        "endTime": 342.75,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "48": {
        "startTime": 343.858,
        "endTime": 348.725,
        "transcript": "Au͡gkut wani Akulmiutaugut willows au͡gkut.",
        "translation": "Those willows are native to the Akula region."
    },
    "49": {
        "startTime": 348.854,
        "endTime": 357.921,
        "transcript": "Tua-ll' maani Kusquqvagmi qagkut atam tua-i atrit ayuqenritpiartut makut Kusquqvagmi naparpallraat.",
        "translation": "Then out here on the Kuskokwim, the big trees on the Kuskokwim have completely different names."
    },
    "50": {
        "startTime": 358.219,
        "endTime": 366.219,
        "transcript": "(Ii-i.) Ilait iciw' au͡gkut enrilnguat (Ii-i.) [?] iciw' neqniqpialriit iluit. (Ii-i.)",
        "translation": "(Yes.) You know some of the willow shoots (Yes.) [?] you know their insides are delicious. (Yes.)"
    },
    "51": {
        "startTime": 366.236,
        "endTime": 373.37,
        "transcript": "Tua-ll' avayait imkut avayait suupanun avuketuit-qaa?",
        "translation": "And do they add their branches into soups?"
    },
    "52": {
        "startTime": 373.677,
        "endTime": 376.977,
        "transcript": "Avukelaqeput iciw' kiagmi? (Wiinga piqaqsaitua.)",
        "translation": "You know we add them in the summer? (I never have before.)"
    },
    "53": {
        "startTime": 377.492,
        "endTime": 381.447,
        "transcript": "Avukelaraput kiagmi tegg'ivailgata.",
        "translation": "We add them in the summer before they harden."
    },
    "54": {
        "startTime": 381.711,
        "endTime": 382.833,
        "transcript": "Aperturaten?",
        "translation": "Did you mention them?"
    },
    "55": {
        "startTime": 382.859,
        "endTime": 384.926,
        "transcript": "Apertuqsaitanka.",
        "translation": "I didn't mention them."
    },
    "56": {
        "startTime": 385.101,
        "endTime": 386.834,
        "transcript": "Napaliuravci.",
        "translation": "Because you're talking about trees."
    },
    "57": {
        "startTime": 386.864,
        "endTime": 396.998,
        "transcript": "Tua-ll' two weeks ago, wiinga avuqaqsaitanka, Anchorage-aarrlua panima waten pianga:",
        "translation": "Then two weeks ago, I've never gathered them before, I went to Anchorage and my daughter said this to me:"
    },
    "58": {
        "startTime": 397.247,
        "endTime": 402.302,
        "transcript": "\"Mom, ciin napanek neqkiuyuitelarcit?\"",
        "translation": "”Mom, why don't you make food out of trees?\""
    },
    "59": {
        "startTime": 403.216,
        "endTime": 404.76,
        "transcript": "\"Canek?“",
        "translation": "\"Out of what?\""
    },
    "60": {
        "startTime": 405.296,
        "endTime": 408.808,
        "transcript": "\"Enrilnguat-llu ciin cuyaitnek neqkiuyuicit?\"",
        "translation": "\"And why don't you make food from the leaves of willow shoots?\""
    },
    "61": {
        "startTime": 408.839,
        "endTime": 410.906,
        "transcript": "Piaqa, \"Nalluanka.\"",
        "translation": "I said to her, \"I don't know them.\""
    },
    "62": {
        "startTime": 411.302,
        "endTime": 426.324,
        "transcript": "Tua-ll' panima pianga Ungalaqlirmiutarnek-gguq enrilnguat cuyaitnek neqkiuranek jar-ami uqiumaluteng friend-aan nerutellrua.",
        "translation": "And then my daughter told me that her friend fed her the leaves of willow shoots in seal oil from Unalakleet."
    },
    "63": {
        "startTime": 427.037,
        "endTime": 429.792,
        "transcript": "Assipiat-gguq.",
        "translation": "She said they were very good."
    },
    "64": {
        "startTime": 429.901,
        "endTime": 437.712,
        "transcript": "Tua-ll' wii piunga, \"Ala-i Kusquqvagmi enrilnguat amllepiartut.\"",
        "translation": "And then I said, \"Wow, there's so many willow shoots on the Kuskokwim.\""
    },
    "65": {
        "startTime": 438.267,
        "endTime": 451.3,
        "transcript": "Waniwa cali uptua kiakan enrilnguanek jar-amun ek'ilua uqirluki naspaaciqua. Panima pisqepiarlua.",
        "translation": "Now, I'm preparing to put willow shoots in a jar with seal oil when summer sets. My daughter really wants me to."
    },
    "66": {
        "startTime": 451.402,
        "endTime": 455.252,
        "transcript": "Neqkat-am nallulallinikput.",
        "translation": "It turns out we don't know what we can eat."
    },
    "67": {
        "startTime": 457.466,
        "endTime": 461.066,
        "transcript": "Neqkanek, neqkaulrianek [?] qanqertua.",
        "translation": "I just talked about what food we can prepare."
    },
    "68": {
        "startTime": 464.515,
        "endTime": 472.104,
        "transcript": "This is Elena Nick and their cousins. She says, you know, there's so many different...",
        "translation": "This is Elena Nick and their cousins. She says, you know, there's so many different..."
    },
    "69": {
        "startTime": 475.767,
        "endTime": 487.633,
        "transcript": "Tua-i-w' qercuagaqata tua-i auluktukait urugcetengnaqluki. Uruyuitait tamaa qercuallret.",
        "translation": "They take care of frostbites by trying to thaw them out. Frostbites don't thaw right away."
    },
    "70": {
        "startTime": 488.447,
        "endTime": 491.725,
        "transcript": "Urugcetengnaqluki tua-i auluktullruit.",
        "translation": "They would take care of them by trying to thaw them."
    },
    "71": {
        "startTime": 497.922,
        "endTime": 500.589,
        "transcript": "Qailluqapiar tuaten?",
        "translation": "How exactly would they do that?"
    },
    "72": {
        "startTime": 500.62,
        "endTime": 507.109,
        "transcript": "Wiinga tua-i tamatumek aptevkenii uitacia. Assikenritaqa.",
        "translation": "Leave me and don't ask me about that. I don't like it."
    },
    "73": {
        "startTime": 509.923,
        "endTime": 516.812,
        "transcript": "Her husband got really frostbitten. He almost died. She doesn't want to talk about it.",
        "translation": "Her husband got really frostbitten. He almost died. She doesn't want to talk about it."
    },
    "74": {
        "startTime": 517.237,
        "endTime": 519.587,
        "transcript": "That reminds her of...",
        "translation": "That reminds her of..."
    },
    "75": {
        "startTime": 519.587,
        "endTime": 524.917,
        "transcript": "[?] there is treatment for frostbite.",
        "translation": "[?] there is treatment for frostbite."
    },
    "76": {
        "startTime": 525.277,
        "endTime": 535.067,
        "transcript": "Well, they, when I was younger, we used to have frostbites on our cheeks when we play too long outside.",
        "translation": "Well, they, when I was younger, we used to have frostbites on our cheeks when we played too long outside."
    },
    "77": {
        "startTime": 535.377,
        "endTime": 545.767,
        "transcript": "And then the old people would let us put a little bit snow on the frozen part for a while and then let it go.",
        "translation": "And then the old people would let us put a little bit snow on the frozen part for a while and then let it go."
    },
    "78": {
        "startTime": 545.767,
        "endTime": 554.042,
        "transcript": "And stay in the house and try to thaw it out with our hands, not by the stove.",
        "translation": "And stay in the hosue and try to thaw it out with our hands, not by the stove."
    },
    "79": {
        "startTime": 554.042,
        "endTime": 564.052,
        "transcript": "Because they say when you put something warm on it, the cold part will go inside, and that'll rot the skin.",
        "translation": "Because they say when you put something warm on it, the cold part will go inside, and that'll rot the skin."
    },
    "80": {
        "startTime": 564.312,
        "endTime": 568.342,
        "transcript": "So, that was the only thing we knew.",
        "translation": "So, that was the only thing we knew."
    },
    "81": {
        "startTime": 574.092,
        "endTime": 578.832,
        "transcript": "Do you know how the snow is supposed to help them...",
        "translation": "Do you know how the snow is supposed to help them..."
    },
    "82": {
        "startTime": 578.837,
        "endTime": 583.637,
        "transcript": "I don't know. They said it's supposed to bring out the frozen part....",
        "translation": "I don't know. They said it's supposed to bring out the frozen part..."
    },
    "83": {
        "startTime": 598.262,
        "endTime": 602.782,
        "transcript": "We can go into another break, fast ten minute break.",
        "translation": "We can go into another break, fast ten minute break."
    },
    "84": {
        "startTime": 610.077,
        "endTime": 611.287,
        "transcript": "Today, they...",
        "translation": "Today, they..."
    },
    "85": {
        "startTime": 611.287,
        "endTime": 614.217,
        "transcript": "Pitsaqa'artenritamken. (Yaa.)",
        "translation": "I apologize. (It's okay.)"
    },
    "86": {
        "startTime": 614.797,
        "endTime": 617.927,
        "transcript": "Yuqerrvigmun piyukuvet. (Yaa.) Ii-i.",
        "translation": "You can go to the bathroom. (Okay.) Okay."
    },
    "87": {
        "startTime": 638.047,
        "endTime": 647.627,
        "transcript": "My husband went out looking for that boy that was missing since Saturday, George Guest Jr., I mean, George Guest.",
        "translation": "My husband went out looking for that boy that was missing since Saturday, George Guest Jr., I mean, George Guest."
    },
    "88": {
        "startTime": 650.952,
        "endTime": 659.552,
        "transcript": "He was gone since Saturday, and then my husband went out looking for his three-wheeler yesterday by plane.",
        "translation": "He was gone since Saturday, and then my husband went out looking for his three-wheeler yesterday by plane."
    },
    "89": {
        "startTime": 659.577,
        "endTime": 664.227,
        "transcript": "Tua-llu he found three-wheeler somewhere between here and Atmaulluaq.",
        "translation": "And then he found a three-wheeler somewhere between here and Atmauthluk."
    },
    "90": {
        "startTime": 664.937,
        "endTime": 667.832,
        "transcript": "Then they started looking for him.",
        "translation": "Then they started looking for him."
    },
    "91": {
        "startTime": 667.832,
        "endTime": 676.322,
        "transcript": "Every time when George lands, he was right there. He takes off, he never see him, he was right there, close to the three-wheeler.",
        "translation": "Every time when George landed, he was right there. He takes off, he didn't see him, he was right there, close to the three-wheeler."
    },
    "92": {
        "startTime": 676.612,
        "endTime": 685.012,
        "transcript": "They found him this morning. And they went out, and George brought him in, and he's not supposed to carry passengers.",
        "translation": "They found him this morning. And they went out, and George brought him in, and he's not supposed to carry passengers."
    },
    "93": {
        "startTime": 688.217,
        "endTime": 689.877,
        "transcript": "He could hardly move.",
        "translation": "He could hardly move."
    },
    "94": {
        "startTime": 689.902,
        "endTime": 691.842,
        "transcript": "Akleng. He's still alive?",
        "translation": "Poor thing. He's still alive?"
    },
    "95": {
        "startTime": 692.077,
        "endTime": 693.632,
        "transcript": "He was still alive.",
        "translation": "He was still alive."
    },
    "96": {
        "startTime": 693.632,
        "endTime": 695.412,
        "transcript": "[?] to Anchorage?",
        "translation": "[?] to Anchorage?"
    },
    "97": {
        "startTime": 695.417,
        "endTime": 696.347,
        "transcript": "I don't know.",
        "translation": "I don't know."
    },
    "98": {
        "startTime": 696.347,
        "endTime": 700.517,
        "transcript": "He said she was still there, his mom and his sister were there.",
        "translation": "He said she was still there, his mom and his sister were there."
    },
    "99": {
        "startTime": 700.917,
        "endTime": 702.817,
        "transcript": "Ran out of gas or something?",
        "translation": "Ran out of gas or something?"
    },
    "100": {
        "startTime": 703.224,
        "endTime": 705.784,
        "transcript": "Something wrong with his three-wheeler.",
        "translation": "Something wrong with his three-wheeler."
    },
    "101": {
        "startTime": 706.049,
        "endTime": 711.319,
        "transcript": "He was gone since Saturday. Saturday, Sunday, Monday, Tuesday.",
        "translation": "He was gone since Saturday. Saturday, Sunday, Monday, Tuesday."
    },
    "102": {
        "startTime": 711.639,
        "endTime": 713.319,
        "transcript": "Three days? (Nakleng.)",
        "translation": "Three days? (Poor thing.)"
    },
    "103": {
        "startTime": 931.127,
        "endTime": 938.267,
        "transcript": "[Ii]tarnek imkunek, iciw' imkut iitaat iluit nertukput? Qupluki tua-i-ll' iluit nerluki.",
        "translation": "Those tall cottongrass, you know that we eat the insides of tall cottongrass? We split them and eat what's inside."
    },
    "104": {
        "startTime": 938.293,
        "endTime": 947.448,
        "transcript": "Tamakunek atsalugpiat caqungqetullruut tupiganek, tupigall'e'rnek. Angluteng tua-i waten.",
        "translation": "Cloudberries would be contained in woven bags out of those, big woven bags. They were big like this."
    },
    "105": {
        "startTime": 947.876,
        "endTime": 957.253,
        "transcript": "Kiagmi iqvarraarluni tauna, tauna-w' tua-i aanalqa tamakucimun naivuurnaurtuq.",
        "translation": "After she picked berries in the summer, my late mother would put them into one of those."
    },
    "106": {
        "startTime": 958.834,
        "endTime": 966.679,
        "transcript": "Teq'iluni-llu qaillun ilututalriamek nunapik elagluku camavet kumlanra tekilluku.",
        "translation": "Then she would make a deep pit, digging into the tundra all the way to the permafrost below."
    },
    "107": {
        "startTime": 967.283,
        "endTime": 971.739,
        "transcript": "Elaggaarluku-llu tauna mermek imangluni.",
        "translation": "And after digging it, it would get filled with water."
    },
    "108": {
        "startTime": 971.84,
        "endTime": 979.369,
        "transcript": "Imangan-llu tauna imna atsalugpianek imalek tupigaq canek",
        "translation": "And when it was filled, that woven grass container filled with cloudberries"
    },
    "109": {
        "startTime": 979.369,
        "endTime": 991.525,
        "transcript": "Imkut-wa tua-i iitaat tupigluki caqukiurluki qaill' akultutaurluki waten uivtaarluki, waten tupigturluki uivtaqluki.",
        "translation": "They would weave tall cottongrass into containers with gaps of a certain size circling them around like this, weaving them into circular patterns like this."
    },
    "110": {
        "startTime": 992.716,
        "endTime": 994.66,
        "transcript": "Terr'it-llu tua-i quulluki.",
        "translation": "And then closing off the bottom."
    },
    "111": {
        "startTime": 994.708,
        "endTime": 1001.474,
        "transcript": "Tua-i imkutun basket-aanek pitukevcetun makutun mingqaatun ayuqluteng.",
        "translation": "They were like those sewn things you call baskets."
    },
    "112": {
        "startTime": 1002.192,
        "endTime": 1004.747,
        "transcript": "Tau͡gaam akultuluteng.",
        "translation": "But they had wide gaps."
    },
    "113": {
        "startTime": 1006.354,
        "endTime": 1009.943,
        "transcript": "Tua-i-ll' tamakuciq imirluku tua-i atsanek.",
        "translation": "And then they would fill that with berries."
    },
    "114": {
        "startTime": 1009.949,
        "endTime": 1021.289,
        "transcript": "Imirraarluku muiran tuavet qillerqerraarluku cali tupigluki tamakunek ilavkuliluni tupigluku.",
        "translation": "After filling it full, they would tie it there, then weave a cord into by weaving grass."
    },
    "115": {
        "startTime": 1022.044,
        "endTime": 1025.711,
        "transcript": "Quulluku cagnilluku una uyii.",
        "translation": "They closed the rim off tightly."
    },
    "116": {
        "startTime": 1026.307,
        "endTime": 1036.251,
        "transcript": "Tua-i-llu tuaten pirraarluku imumun tuavet elallminun mermek imalegmun ekluku.",
        "translation": "And then after doing that, she would put it into the pit she dug filled with water."
    },
    "117": {
        "startTime": 1036.473,
        "endTime": 1042.55,
        "transcript": "Ekraarluku-llu qanirluku napanek, painga nunirluku patuluku.",
        "translation": "Then after putting it in, she would line the sides with trees, then close off the mouth with dirt."
    },
    "118": {
        "startTime": 1042.997,
        "endTime": 1045.764,
        "transcript": "Kiagpak tua-i tuanlluni.",
        "translation": "It would stay there all summer."
    },
    "119": {
        "startTime": 1047.365,
        "endTime": 1052.876,
        "transcript": "Tua-i-llu uksuarmi uksuqataan cikuqataan nuggluku.",
        "translation": "And then in the fall as it was going to freeze close to winter, she would take it out."
    },
    "120": {
        "startTime": 1053.582,
        "endTime": 1058.16,
        "transcript": "Imumek tua-i cikungarrluni asvairpailgan nuggluku.",
        "translation": "Before it froze and got stuck, she would take it out."
    },
    "121": {
        "startTime": 1058.489,
        "endTime": 1066.678,
        "transcript": "Nuggnaurai tang assiqapiar. Tuar nutaan iqvallret atsat iluani taum tupigam.",
        "translation": "She would take them out and they were very good. They were like freshly picked berries in that woven grass container."
    },
    "122": {
        "startTime": 1067.01,
        "endTime": 1069.744,
        "transcript": "Assiqapiarluteng.",
        "translation": "They were very good."
    },
    "123": {
        "startTime": 1069.987,
        "endTime": 1078.918,
        "transcript": "Cali-llu tamakut allat quagcit, imkut tua-i green-aaruluteng quagcit tua-i nallunrilkeci.",
        "translation": "And the other ones, the sourdock, you know those green sourdock."
    },
    "124": {
        "startTime": 1079.479,
        "endTime": 1089.323,
        "transcript": "Kenirluki qallarvautelluki, uungata-llu ipugluki nengllacirraarluki tua-i-am cali tupigamun ekluki.",
        "translation": "She boiled them, and when they were cooked, she would ladle them out, cool them off, and put them into a woven grass container."
    },
    "125": {
        "startTime": 1089.495,
        "endTime": 1100.261,
        "transcript": "Tuaten-am cali elaulluki taumun tua-i teq'ermun elanermun ekluki kit'elluki.",
        "translation": "The same way, she would bury them into a put like that so that they would be submerged."
    },
    "126": {
        "startTime": 1100.275,
        "endTime": 1110.504,
        "transcript": "Tua-i-am uitavkarluki. Tua-i-llu cikuluni asvaiqataan-am tua-i tuaten nuggluku tautun imutun atsalugpiarutetun.",
        "translation": "And she left them. Then it froze, and as they were going to get stuck, she would take it out like that cloudberry container."
    },
    "127": {
        "startTime": 1111.371,
        "endTime": 1115.226,
        "transcript": "Kumelqertelluki, cikuqertelluki.",
        "translation": "She kept them cool, kept them frozen."
    },
    "128": {
        "startTime": 1115.273,
        "endTime": 1119.729,
        "transcript": "Tua-i uksurpak neqautekateng tuaten pitullruit.",
        "translation": "That's what they did to their winter food supply."
    },
    "129": {
        "startTime": 1120.242,
        "endTime": 1123.83,
        "transcript": "Maani-qaa atsarrlitullruaci tamakut quagcit?",
        "translation": "Would you make a sourdock-berry mixture here?"
    },
    "130": {
        "startTime": 1125.898,
        "endTime": 1128.754,
        "transcript": "Atsaurrlilallruuci-qaa maani?",
        "translation": "Would you make sourdock-berry mixtures?"
    },
    "131": {
        "startTime": 1130.579,
        "endTime": 1133.534,
        "transcript": "Curanek auluki quagcit tamakut?",
        "translation": "Would you add blueberries to the sourdock?"
    },
    "132": {
        "startTime": 1133.876,
        "endTime": 1136.376,
        "transcript": "Piksaitellruukut tuaten.",
        "translation": "We didn't do that."
    },
    "133": {
        "startTime": 1137.311,
        "endTime": 1139.734,
        "transcript": "Qagaani atsaurrlitullruut.",
        "translation": "They would make sourdock-berry mixtures up north."
    },
    "134": {
        "startTime": 1140.097,
        "endTime": 1142.597,
        "transcript": "They cook the sourdock.",
        "translation": "They cook the sourdock."
    },
    "135": {
        "startTime": 1144.165,
        "endTime": 1154.509,
        "transcript": "After they're cooked, they mix blueberries with it, and then let it [?] she described in the ground.",
        "translation": "After they're cooked, they mix blueberries with it, and then let it [?] she described in the ground."
    },
    "136": {
        "startTime": 1154.564,
        "endTime": 1164.697,
        "transcript": "And when it's cooled off in the fall time [?]. And that's another way of preserving the blueberries because the blueberries are harder to keep than the salmonberries.",
        "translation": "And when it's cooled off in the fall time [?]. And that's another way of preserving the blueberries because the blueberries are harder to keep than the salmonberries."
    },
    "137": {
        "startTime": 1169.852,
        "endTime": 1171.974,
        "transcript": "Tua-llu-q' mumigtarkan au͡gna?",
        "translation": "So are you going to translate that?"
    },
    "138": {
        "startTime": 1172.168,
        "endTime": 1175.468,
        "transcript": "She was talking about her mother that...",
        "translation": "She was talking about her mother that..."
    },
    "139": {
        "startTime": 1175.613,
        "endTime": 1176.502,
        "transcript": "Cat?",
        "translation": "What?"
    },
    "140": {
        "startTime": 1176.534,
        "endTime": 1179.779,
        "transcript": "Maklaarat-gguq augit...",
        "translation": "The seal blood..."
    },
    "141": {
        "startTime": 1179.82,
        "endTime": 1184.831,
        "transcript": "Maklaalegmiungunritua-gguq. Wii makumiunguunga. Nalluanka-gguq maklaalget.",
        "translation": "Tell him I don't live where there's seals. I live here. Tell him I don't know about seals."
    },
    "142": {
        "startTime": 1184.843,
        "endTime": 1192.043,
        "transcript": "Ceńarmiut tau͡gaam imkuk angukara'urluuk imkuk unuaq ilakeqallregput, taukuk-gguq apeskilikek.",
        "translation": "But the coastal people, tell him to ask the two old men that joined us this morning."
    },
    "143": {
        "startTime": 1192.822,
        "endTime": 1195.544,
        "transcript": "Imarpigmiunguuk-gguq taukuk.",
        "translation": "Tell him they're coastal people."
    },
    "144": {
        "startTime": 1196.136,
        "endTime": 1199.925,
        "transcript": "Qanrutqercikek. Qanrullukek ingkuk.",
        "translation": "Please tell them. Tell them over there."
    },
    "145": {
        "startTime": 1200.238,
        "endTime": 1208.005,
        "transcript": "We're not from the place where there's lots of seal or those things.",
        "translation": "We're not from the place where there's lots of seals or those things."
    }
};